<template lang="pug">
  section.banner-container(ref="container" :class="classes" :style="{ ...style, height: `${height}px` }")
    Picture(
      v-if="image"
      :show-spinner="false"
      :image="image"
      :lazy="true"
      :optimize="optimize"
      missing-icon="exclamation-triangle"
      object-fit="cover"
      :title="title"
    )
      p(v-if="title") {{ title }}
      small(v-if="subTitle") {{ subTitle }}
</template>

<script>
import { get, trim, debounce } from '@/helpers';
import section from '@/mixins/section';

export default {
  name: 'Banner',
  mixins: [section],
  data() {
    return {
      width: undefined
    };
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      return get(this.content, 'images.0');
    },
    content() {
      return get(this.section, 'contents.0');
    },
    title() {
      return get(this.content, 'title');
    },
    subTitle() {
      return get(this.content, 'sub_title');
    },
    height() {
      let fr = 160;
      let height = 2 * fr;

      const config = this.settings.find(setting => setting.key === 'height');
      if (config && config.value) {
        switch (config.value) {
          case 'small':
            height = 1 * fr;
            break;

          case 'large':
            height = 3 * fr;
            break;
        }
      }

      return height;
    },
    optimize() {
      let optimize = 'traffic';

      const config = this.settings.find(setting => setting.key === 'optimize-image');
      if (config) optimize = config.value;

      return optimize;
    }
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.banner-container
  background: $skeletonColor
  position: relative
  .picture-container
    width: 100%
    height: 100%
</style>
